import './App.css';
import Navbar from './components/sections/Navbar';
import Hero from './components/sections/Hero';
import Stats from './components/sections/Stats';
import Problem from './components/sections/Problem';
import Solution from './components/sections/Solution';
import HowItWorks from './components/sections/HowItWorks';
import WhoWeServe from './components/sections/WhoWeServe';
import Pricing from './components/sections/Pricing';
import WhyNow from './components/sections/WhyNow';
import FinalCTA from './components/sections/FinalCTA';
import Booking from './components/sections/Booking';
import Footer from './components/sections/Footer';

function App() {
  return (
    <div className="font-sans bg-[#FAFAF7] text-[#1A1A1A]">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Problem />
        <Solution />
        <HowItWorks />
        <WhoWeServe />
        <Pricing />
        <WhyNow />
        <FinalCTA />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}

export default App;
